@file:UseSerializers(BigDecimalSerializer::class)

package net.sergeych.ugdx.shared.trader

import com.ionspin.kotlin.bignum.decimal.BigDecimal
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import net.sergeych.sprintf.sprintf
import net.sergeych.ugdx.shared.BigDecimalSerializer

/**
 * Depth of market snapshot as send by push service
 * @param currencyPair as is
 * @param createdAt when created on server side
 * @param buyPositions unsorted list
 * @param sellPositions unsorted list
 * @param lastRate last operation rate, null means this pair has no deals at all
 * @param lastChangeDirection last rate change direction: +1 raises, -1 drops, 0 - no change, null - no information
 * @param lastIsBuy type of the last deal, null means there is no last deal yet.
 */
@Serializable
class DepthOfMarket(
    val currencyPair: CurrencyPair,
    val createdAt: Instant,
    val serial: Long,
    /**
     * Purchase positions. This list is not sorted!
     */
    val buyPositions: List<Position>,
    val sellPositions: List<Position>,
    val lastRate: BigDecimal? = null,
    val lastChangeDirection: Int? = null,
) {
    @Serializable
    data class Position(
        val limit: BigDecimal,
        val amount: BigDecimal,
        val count: Int
    ) {
        override fun toString(): String {
            return "%8f %6f (%d)".sprintf(limit.doubleValue(), amount.doubleValue(), count)
        }
    }

    override fun equals(other: Any?): Boolean {
        return other is DepthOfMarket && other.serial == serial && other.currencyPair == currencyPair
    }

}